export const GET_DASHBOARD_ASSETALLOCATION_ABORTED =
  'GET_DASHBOARD_ASSETALLOCATION_ABORTED';
export const GET_DASHBOARD_ASSETALLOCATION_REQUESTED =
  'GET_DASHBOARD_ASSETALLOCATION_REQUESTED';
export const GET_DASHBOARD_ASSETALLOCATION_COMPLETED =
  'GET_DASHBOARD_ASSETALLOCATION_COMPLETED';
export const GET_DASHBOARD_ASSETALLOCATION_FAILED =
  'GET_DASHBOARD_ASSETALLOCATION_FAILED';
export const RESET_DASHBOARD_ASSETALLOCATION_REQUESTED =
  'RESET_DASHBOARD_ASSETALLOCATION_REQUESTED';
export const RESET_DASHBOARD_ASSETALLOCATION_COMPLETED =
  'RESET_DASHBOARD_ASSETALLOCATION_COMPLETED';
